var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkippedGraphIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "18px",
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graph-stats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/molecules/avatar/skip",
    transform: "translate(-8.000000, -11.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph-stats",
    transform: "translate(9.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.4946329 L3.5,7.4946329 C4.10567257,7.49480113 4.65201797,7.13070236 4.885,6.5716329 L7.485,0.456632898 C7.60657001,0.170602943 7.89195801,-0.0108138449 8.20254518,0.000500402045 C8.51313235,0.011814649 8.78456393,0.213515579 8.885,0.507632898 L13.619,15.2326329 C13.7194361,15.5267502 13.9908676,15.7284511 14.3014548,15.7397654 C14.612042,15.7510796 14.89743,15.5696629 15.019,15.2836329 L17.614,8.4176329 C17.846982,7.85856344 18.3933274,7.49446466 18.999,7.4946329 L22.499,7.4946329",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedGraphIcon);
export default __webpack_public_path__ + "static/media/skipped-graph-icon.eed01773f2b7128ed787c1aa225ba4bf.svg";
export { ForwardRef as ReactComponent };